<template>
    <div class="converter-summary">
        <div>
            <h1>{{ heading }}</h1>
            <p>{{ description }}</p>
            <div class="converter-summary__buttons">
                <button
                    :disabled="successCount == 0"
                    class="nectar-button medium regular accent-color regular-button"
                    style="background-color: #0071EA;"
                    @click="$emit('save')"
                >
                    Download ZIP file
                </button>
                <button
                    class="nectar-button medium regular regular-button"
                    style="color: black; background-color: white;"
                    @click="$emit('done')"
                >
                    Done
                </button>
            </div>
        </div>
        <div class="converter-summary__counts">
            <span v-if="successCount">
                <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 38 38"><path fill-rule="evenodd" clip-rule="evenodd" d="M0 19C0 8.51 8.51 0 19 0s19 8.51 19 19-8.51 19-19 19S0 29.49 0 19ZM19 2.923C10.124 2.923 2.923 10.124 2.923 19c0 8.875 7.201 16.077 16.077 16.077 8.875 0 16.077-7.201 16.077-16.077 0-8.876-7.201-16.077-16.077-16.077Z" fill="#0071EA"/><path fill-rule="evenodd" clip-rule="evenodd" d="M28.49 10.351c.604.533.683 1.48.175 2.114l-12 15a1.404 1.404 0 0 1-1.07.535 1.398 1.398 0 0 1-1.085-.497l-5.143-6a1.553 1.553 0 0 1 .106-2.118 1.381 1.381 0 0 1 2.017.112l4.044 4.717 10.943-13.679a1.382 1.382 0 0 1 2.013-.184Z" fill="#0071EA"/></svg>
                <span>{{ successCount }} file{{ successCount > 1 ? 's' : '' }} converted</span>
            </span>
            <span v-if="failCount">
                <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 38 38"><path fill-rule="evenodd" clip-rule="evenodd" d="M0 19C0 8.51 8.51 0 19 0s19 8.51 19 19-8.51 19-19 19S0 29.49 0 19ZM19 2.923C10.124 2.923 2.923 10.124 2.923 19c0 8.875 7.201 16.077 16.077 16.077 8.875 0 16.077-7.201 16.077-16.077 0-8.876-7.201-16.077-16.077-16.077Z" fill="#EA3800"/><path fill-rule="evenodd" clip-rule="evenodd" d="M12.12 12.12c.571-.57 1.497-.57 2.067 0L25.88 23.813a1.461 1.461 0 1 1-2.067 2.067L12.12 14.187a1.461 1.461 0 0 1 0-2.067Z" fill="#EA3800"/><path fill-rule="evenodd" clip-rule="evenodd" d="M25.88 12.12c.57.571.57 1.497 0 2.067L14.187 25.88a1.461 1.461 0 1 1-2.066-2.067L23.813 12.12c.57-.57 1.496-.57 2.067 0Z" fill="#EA3800"/></svg>
                <span>{{ failCount }} file{{ failCount > 1 ? 's' : '' }} failed</span>
            </span>
        </div>
    </div>
</template>

<script>
export default {
    name: "Summary",
    props: {
        successCount: {
            type: Number,
            default: 0
        },
        failCount: {
            type: Number,
            default: 0
        }
    },
    computed: {
        heading() {
            return this.successCount > 0 ? 'Complete' : 'Failed';
        },
        description() {
            return this.successCount > 0 ? 'Your download should start automatically.' : 'Your files failed to convert.';
        }
    }
}
</script>

<style>
.converter-summary > * {
    padding: 45px;
}

.converter-summary h1 {
    margin: 0;
}

.converter-summary__buttons {
    margin-top: 25px;
}

.converter-summary__buttons button {
    border: none;
    margin-right: 10px;
    cursor: pointer;
}

.converter-summary__counts {
    font-weight: 800!important;
}

.converter-summary__counts svg {
    width: 30px;
    margin-right: 10px;
}

.converter-summary__counts > span {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
}

@media only screen and (min-width: 800px) {
    .converter-summary {
        display: flex;
        align-items: center;
    }

    .converter-summary > :first-child {
        border-right: 1px solid white;
    }
}

@media only screen and (max-width: 800px) {
    .converter-summary > :first-child {
        border-bottom: 1px solid white;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/Summary.vue